import {DatasetField} from '../../model/dataset/field/dataset-field';
import {DatasetFieldType} from '../../model/dataset/dataset-field-type';
import {DatasetFieldSpecificType} from '../../model/dataset/dataset-field-specific.type';
import {TableColumnType} from '../../model/upload/table/table-column';

export class DatasetUtils {

    /**
     * Groups fields into the two-level tags[0] -> tags[1] -> fields structure the
     * Filter/Analytics field menus render, then merges that into the groups built so far.
     * Shared by the dashboard and the count/aggregate/ranking report components, which all
     * need the same structure. Fields are expected to be sorted by the caller.
     */
    static mergeTagGroupedFields(fields: DatasetField[], existingGroupedFields: any): any {
        if (!fields || fields.length === 0) {
            return existingGroupedFields;
        }
        const groupedFields = fields.reduce(
            (groups: any, item: any) => ({
                ...groups,
                [item.tags[0]]: [
                    ...(groups[item.tags[0]] || [])
                        .map(group => group[item.tags[1]] ? {
                            ...group, [item.tags[1]]:
                                [...group[item.tags[1]], item]
                        } : group
                        ),
                    ...(groups[item.tags[0]]?.some(group => group[item.tags[1]]) ? [] : [{ [item.tags[1]]: [item] }])
                ]
            }),
            []
        );
        return existingGroupedFields && Object.keys(existingGroupedFields).length
            ? { ...existingGroupedFields, ...groupedFields }
            : groupedFields;
    }

    static getDatasetFieldType(field: DatasetField): DatasetFieldType {
        switch (field.type) {
            case DatasetFieldSpecificType.CHECKBOX_TEXT_FIELD:
            case DatasetFieldSpecificType.EMAIL_TEXT_FIELD:
            case DatasetFieldSpecificType.LONG_TEXT_FIELD:
            case DatasetFieldSpecificType.RADIO_TEXT_FIELD:
            case DatasetFieldSpecificType.SELECT_TEXT_FIELD:
            case DatasetFieldSpecificType.SHORT_TEXT_FIELD:
            case DatasetFieldSpecificType.TELEPHONE_TEXT_FIELD:
            case DatasetFieldSpecificType.URL_TEXT_FIELD:
                return DatasetFieldType.TEXT;
            case DatasetFieldSpecificType.DATE_FIELD:
                return DatasetFieldType.DATE_TIME;
            case DatasetFieldSpecificType.NUMBER_FIELD:
                return DatasetFieldType.NUMBER;
        }
    }

    static createUniqueIdentifierForDatasetField(datasetId: string, fieldId: string) {
        return datasetId + '_' + fieldId;
    }

    static createUniqueIdentifierForDatasetFieldForGroup(datasetId: string, fieldId: string, index:number) {
        return datasetId + '_' + fieldId + '_' + index.toString();
    }

    static getTableColumnType(field: DatasetField): TableColumnType {
        switch (field.baseType) {
            case DatasetFieldType.TEXT:
                return field.isArray ? TableColumnType.TEXT_LIST : TableColumnType.TEXT;
            case DatasetFieldType.NUMBER:
                return field.isArray ? TableColumnType.DECIMAL_LIST : TableColumnType.DECIMAL;
            case DatasetFieldType.DATE_TIME:
                return field.isArray ? TableColumnType.DATE_LIST : TableColumnType.DATE;
        }
    }

}
